import React from "react";
import { Button } from "@mui/material";

function NextButton({ name, icon, handleClick, className, title, color, disabled }) {
	return (
		<Button
			disabled={disabled}
			name={name}
			variant={"contained"}
			className={` !px-4 !capitalize ${className}`}
			sx={{
				width: 180,
				borderRadius: 3,
				mx: 2,
				py: 1,
			}}
			color={color ? color : "primary"}
			startIcon={icon}
			onClick={handleClick}>
			{title}
		</Button>
	);
}

export default NextButton;
